export default __webpack_public_path__ + "static/media/seo2.e180d6a5.png";